
// import { templateRef } from '@vueuse/core';
import IMask, { MaskedDynamicOptions } from 'imask';
import { defineComponent, nextTick, onBeforeUnmount, PropType, reactive, toRefs, watch } from 'vue';
import { MASK_MODELS } from '../utils';

interface Data {
  el?: HTMLElement,
  internalValue?: [string,number],
  mask: any, // any because it can be from any mask type. (builtin or custom)
}

const KoddeinFormText = defineComponent({
  name: "KoddeinFormText",
  props: {
    id: {
      type: String,
      required: true,
    },
    name: {
      type: String,
      default: undefined,
    },
    /** input typ */
    type: {
      type: String,
      required: true,
    },
    /** input value */
    value: {
      type: [String, Number],
      default: undefined,
    },
    /** input error */
    error: {
      type: String,
      default: undefined,
    },
    /** mask name for IMask lib */
    mask: {
      type: [String, Object] as PropType<FormMask|MaskedDynamicOptions>, // string check our internal mask || it's a Masked options from imask
      default: undefined,
    },
    /** aria-label text */
    ariaLabel: {
      type: String,
      default: undefined,
    },
    /** autocomplete text */
    autocomplete: {
      type: String,
      default: undefined,
    },
  },
  emits: ['inputChange', 'onFocus', 'onBlur', 'customEvent'],
  setup(props, { emit }){
    const data:Data = reactive(
      {
        el: undefined,
        /** @param {any} internalValue - clone value
         * - because we must not change props
         * - in `watch` will sync value within internalValue
         */
        internalValue: undefined,
        // for imask complete object
        mask: undefined,
      }
    );

    // next tick because we need that ref input.
    nextTick(() => {
      /* get dynamic component from cpn name */
      if (props.mask) {
        let maskObject = null;
        if (typeof props.mask === 'string' && MASK_MODELS[props.mask as FormMask]) {
          maskObject = MASK_MODELS[props.mask as FormMask];
        } else {
          // if we ever pass a custom object on a field... it will pass make sure to check the imask doc. 
          maskObject = props.mask;
        }
  
        if (maskObject) {
          data.mask = IMask(data.el as HTMLElement, maskObject as MaskedDynamicOptions);
  
          // 'accept' event fired on input when mask value has changed
          data.mask.on('accept', accept);
  
          // 'complete' event fired when the value is completely filled
          // Note: this makes sense only for Pattern-based masks
          data.mask.on('complete', complete);
        }
      }
    })

    onBeforeUnmount(() => {
      data.mask?.destroy();
    })

    /**
     * Watch value, on value update -> set internal value
     */
    watch(
      ()=>props.value,
      (value:any) => { 
        data.internalValue = value;
      },
      { immediate:true }
    )

    /**
     * Watch internal value, on value update -> send value to parent
     */
    watch(
      ()=>data.internalValue,
      (value) => { 
        if (value === props.value || data.mask) return;
        emit('inputChange', value);
      },
      // { immediate:true }
    )

    const focus = () => {
      emit('onFocus');
    }
    const blur = () => {
      emit('onBlur');
    }
    const accept = () => {
      // console.debug('[TextField] onAccept', data.mask );
      emit('customEvent', {
        event: 'mask:accept',
        value: data.mask,
      });
      emit('inputChange', data.mask.value);
      data.internalValue = data.mask.value;
    }
    const complete = () => {
      emit('customEvent', {
        event: 'mask:complete',
        value: data.mask,
      });
      emit('inputChange', data.mask.value);
      data.internalValue = data.mask.value;
    }

    return {
      ...toRefs(data), //data
      isFocus: focus,
      isBlur: blur,
      onAccept: accept,
      onComplete: complete,
    }; 
  },
});
export default KoddeinFormText
